export function downloadIcon() {
  return (
    <svg
      width={"16"}
      height={"16"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.8"}
      aria-hidden={"true"}
    >
      <path d={"M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5"}></path>
    </svg>
  );
}
